import { EVENT_TYPE_ENUM_MAP, FIELD_ENUM_MAP } from '../constants';

/**
 * i18n enum namespace for one history entry, or null when its values are free text.
 * The event type wins: a status change names its enum directly, a field change via its name.
 */
export function resolveHistoryEnumNamespace(
  eventType: string | null,
  fieldName?: string | null
): string | null {
  const byEventType = eventType === null ? undefined : EVENT_TYPE_ENUM_MAP[eventType];
  if (byEventType !== undefined) {
    return byEventType;
  }
  return (fieldName ? FIELD_ENUM_MAP[fieldName] : undefined) ?? null;
}
